import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp({ type }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.kitF} kitF`}>
            <div className="kit-ms1">{t('presale.product.kitF_ms1')}</div>
        </div>
    );
}
